import { PropsWithChildren } from 'react';
import { Platform, Text } from 'react-native';
import { tv } from '@/common/theme/tv.config';
import { textColorVariants } from '@/common/theme/variants';

export function Heading({ className, level, color, children }: THeadingProps) {
  const Component = Platform.OS === 'web' ? `h${level}` : Text;
  const nativeProps =
    Platform.OS !== 'web'
      ? {
          allowFontScaling: false,
        }
      : {};

  return (
    <Component
      className={styles.root({ level, color, className })}
      {...nativeProps}
    >
      {children}
    </Component>
  );
}

const styles = {
  root: tv({
    base: 'shrink font-F37Bold',
    variants: {
      level: {
        1: 'text-[2.4rem] leading-[1.2] md:text-[4rem]',
        2: 'text-[2.2rem] leading-[1.2] md:text-[3.2rem]',
        3: 'text-[2.0rem] leading-[1.2] md:text-[2.4rem]',
        4: 'text-[1.8rem] leading-[1.2] md:text-[2.0rem]',
        5: 'text-[1.6rem] leading-[1.3]',
      },
      color: textColorVariants,
    },
    defaultVariants: {
      color: 'neutral30',
    },
  }),
};

export type THeadingProps = {
  className?: string;
  level: 1 | 2 | 3 | 4 | 5;
  color?: keyof typeof textColorVariants;
} & PropsWithChildren;
